import type RootStore from "stores/RootStore";
import type ServiceStore from "stores/ServiceStore";
import { RouteType } from "types/RouteType";

/**
 * Daily Report log — B6 and B7 of the 2026-10-08 feedback.
 *
 * Grouped under Install alongside the Daily Report (Josh, 2026-10-12), so it
 * appears in the nav and the omnibar's quick-nav. See DailyReport.Route.ts:
 * grouping gates nothing today, because PermissionManager's role check has no
 * live callers — only `requiresAuth` runs. It needs a rolePermissions record
 * only once route permissions are switched back on.
 */
const DailyReportLogRoute: RouteType = {
  name: "Daily Report Log",
  path: "/install/daily-report-log",
  title: "Daily Report Log",
  layout: "/app",
  group: "Install",
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  viewportCard: {
    header: {
      component: () => import("./DailyReport.Page"),
      title: "Daily Report Log",
      enableRefreshButton: true,
      enableBackButton: true,
    },
    body: {
      component: () => import("./DailyReportLog.Body"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }: { rootStore: RootStore }) => {
    try {
      const projectsStore = (
        rootStore as unknown as Record<string, ServiceStore | undefined>
      ).projectsStore;
      await Promise.allSettled([projectsStore?.find?.({ query: { $limit: 1000 } })]);
    } catch (error) {
      console.warn("[DailyReportLogRoute] warm-load failed:", error);
    }
    return true;
  },
};

export default DailyReportLogRoute;
